import * as angular from 'angular';
import * as _ from 'lodash';
import template from './shops.tpl.html';
import EditShopName, { openEditShop } from "./editShop.controller";
import { apsViewModels } from "../../shared/dto/APS.ViewModels";
import { States } from "../../shared/config/constant.module";
import ShopServiceName, { ShopService } from "../../services/shops/shops.service";
import LoaderServiceName, { LoaderService } from "../../components/loader/loader.service";
import NavigationServiceName, { NavigationService } from "../../services/navigation/navigation.service";

let requires = [EditShopName, ShopServiceName, LoaderServiceName, NavigationServiceName];

export interface ShopsViewController {
  plantName: string;
  plantNames: string[];
  shops: apsViewModels.ShopItem[];
  editShop(shop: apsViewModels.ShopItem): void;
}

export default angular.module('aps.controller.shops', requires)
  .config(($stateProvider: angular.ui.IStateProvider) => {
    $stateProvider.state({
      name: States.SHOPS,
      url: '/admin/shops',
      controller: 'ShopsCtrl as shopsCtrl',
      template: template,
      data: {
        pageTitle: 'Shops',
        authorizeAdmin: true
      }
    });
  })
  .controller('ShopsCtrl', shopsCtrl)
  .name;

function shopsCtrl(
  $modal: mm.foundation.modal,
  shopService: ShopService,
  navigationService: NavigationService,
  loaderService: LoaderService
): ShopsViewController {

  let vm = {} as ShopsViewController;

  loaderService.loadingPromise(
    shopService.getShops().then((data: apsViewModels.ShopItem[]) => {
      vm.shops = data;
      vm.plantNames = _.uniq(_.map(vm.shops, 'plantName')).sort();
      return navigationService.getNavigation().then(nav => {
        vm.plantName = nav.selectedPlant.name;
      });
    }));

  let launchEditor = (shop?: apsViewModels.ShopItem) => {
    let result = openEditShop({
      shop: shop
    }, $modal);

    result.then(function (editedShop) {
      if (editedShop) {
        if (shop) {
          _.assign(shop, editedShop);
          return;
        }
        vm.shops.unshift(editedShop);
      }
    });
  };

  vm.editShop = (shop: apsViewModels.ShopItem) => {
    launchEditor(shop);
  };

  return vm;
}



// WEBPACK FOOTER //
// ./src/app/controllers/shops/shops.controller.ts